import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailToName'
})
export class EmailToNamePipe implements PipeTransform {

  transform(value: string): string {
    return value
      .split('@')[0]
      .toLowerCase()
      .split('.')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

}
